import UAParser from 'ua-parser-js';
import { v4 as uuidv4 } from 'uuid';

interface FormatAndBuildAnalyticEventsProps extends Record<string, unknown> {
  eventName: string;
}

export const formatAndBuildAnalyticEvent = ({
  eventName,
  ...rest
}: FormatAndBuildAnalyticEventsProps) => {
  const now = new Date();
  const { browser, os } = UAParser(navigator.userAgent);

  const osName = os.name ?? '';

  let deviceType = '';
  if (os.name === 'Android') deviceType = 'android_phone';
  else if (os.name === 'iOS') deviceType = 'i_phone';

  const metadata = {
    eventId: uuidv4(),
    client: 'WebApp',
    browserName: browser.name || '',
    browserVersion: browser.version || '',
    currentUrl: window.location.href,
    deviceType,
    os: osName,
    timestampDate: now.toISOString(),
  };

  const event = {
    action: 'send',
    data: {
      eventName,
      metadata: {
        ...metadata,
        ...rest,
      },
    },
  };

  return event;
};

export default formatAndBuildAnalyticEvent;
